import { z } from "zod/v4";

import {
  ShippingActionList,
  ShippingSettingsSchema,
} from "../../../dtos/shipping-profile";

export const ShippingActionsRequestBodySchema = z
  .object({
    settings: ShippingSettingsSchema,
  })
  .optional()
  .nullish();

export type ActionShippingRequestBodyType = z.infer<
  typeof ShippingActionsRequestBodySchema
>;

export const ShippingActionsResponseBodySchema = z.object({
  actionRequested: z.boolean(),
});

export type ShippingActionsResponseBodyType = z.infer<
  typeof ShippingActionsResponseBodySchema
>;

export const ShippingActionsRequestPathParamsSchema = z.object({
  experienceId: z.uuid(),
  action: z.enum(ShippingActionList),
});

export type ShippingActionsRequestPathParamsType = z.infer<
  typeof ShippingActionsRequestPathParamsSchema
>;
